__turbopack_context__.v({
  "btnContainer": "es-yza_btnContainer",
  "modal": "es-yza_modal",
  "modalContainer": "es-yza_modalContainer",
  "offersModalFadeIn": "es-yza_offersModalFadeIn",
  "root": "es-yza_root",
});
